import { ArrowRight, Trophy } from "lucide-react";
import Link from "next/link";

const ScholarChallenge = () => {
  return (
    <div className="container max-w-[1400px] mx-auto py-[48px] sm:py-[60px] md:py-[80px] lg:py-[100px] xl:py-[120px] px-4 xxs:px-6 sm:px-[40px]">

      <div className="bg-[#021A38] shadow-[0px_8px_32px_0px_rgba(0,0,0,0.2)] rounded-3xl py-6 sm:py-16 px-6 sm:px-12 flex flex-col items-center justify-center text-center">
        <div className="flex items-center gap-2">
          <p className="text-[16px] flex items-center gap-2 sm:text-[20px] font-bold tracking-widest text-[#D2963B] uppercase ff_poppins">
            <Trophy className="text-[#D2963B] w-5 h-5 sm:w-6 sm:h-6" />
            EDVIA EXCLUSIVE
          </p>
        </div>

        <h2 className="mt-5 text-white font-bold text-[24px] xxs:text-[26px] xs:text-[28px] sm:text-3xl md:text-4xl lg:text-[48px] leading-tight ff_poppins max-w-[900px]">
          Chance to earn up to <span className="text-[#1776F0]">₹10 Lakh</span> in scholarships
        </h2>

        <p className="mt-3 text-[#D1D5DC]/80 text-[16px] xxs:text-[18px] xs:text-[20px] sm:text-[22px] ff_poppins max-w-[600px]">
          Take a 15-minute test for a chance to earn a scholarship. Amount depends on test score, eligibility and university terms. T&Cs apply.
        </p>

        <Link
          href="/scholarship-test"
          className="w-full sm:w-fit bg-[#1776F0] hover:bg-[#156cdb] transition-all duration-300 ease-in-out font-semibold text-[16px] sm:text-[20px] text-white py-3 sm:py-3.5 px-8 rounded-full flex items-center justify-center gap-2 mt-6 sm:mt-8 hover:scale-105 focus:scale-105 shadow-[0px_4px_12px_rgba(23,118,240,0.3)]"
        >
          Take the test
          <ArrowRight className="text-white w-3.5 h-3.5 sm:w-4 sm:h-4" />
        </Link>
        {/* Footer Text */}
        <p className="text-[#CBD5E1] text-[10px] sm:text-xs mt-4 ff_poppins">
          *T&Cs apply
        </p>

      </div>
    </div>
  );
};

export default ScholarChallenge;
